import React from "react";
import { Link } from "react-router-dom";
import {
	TrendingMainContainer,
	SectionTitle,
	SectionTitleSpan,
	RowImagesContainer,
	FirstImageContainer,
	ImageLink,
	ImageContainer,
	Image,
	ImageTitle,
} from "../../styles/TrendingMain";

// images
import homeAscentImg from "assets/images/lethomeshine/homeAscent.jpg";
import outdoorLivingImg from "assets/images/lethomeshine/outdoorLiving.jpg";
import vaseImg from "assets/images/lethomeshine/vase.jpg";

function TrendingMain(props) {
	return (
		<TrendingMainContainer>
			<div className="container">
				<SectionTitle>
					<SectionTitleSpan>THIS NEW YEAR</SectionTitleSpan>
					Let your home shine with unique yet functional design
				</SectionTitle>

				<RowImagesContainer>
					{/* img sec */}
					<FirstImageContainer>
						<ImageLink>
							<Link to="/category/vases-vessels?id=28" className="text-decoration-none d-block">
								<ImageContainer>
									<Image
										src={vaseImg}
										className="img-fluid"
									/>
								</ImageContainer>
								<ImageTitle className="mt-1 mb-2">Vases & Vessels</ImageTitle>
							</Link>
						</ImageLink>
					</FirstImageContainer>

					{/* img sec */}
					<FirstImageContainer>
						<ImageLink>
							<Link to="/category/outdoor-garden?id=16" className="text-decoration-none d-block">
								<ImageContainer>
									<Image
										src={outdoorLivingImg}
										className="img-fluid"
									/>
								</ImageContainer>
								<ImageTitle className="mt-1 mb-2">Outdoor Living</ImageTitle>
							</Link>
						</ImageLink>
					</FirstImageContainer>
				</RowImagesContainer>

				{/* img sec */}
				<FirstImageContainer>
					<ImageLink>
						<Link to="/category/home-accents?id=7" className="text-decoration-none d-block">
							<ImageContainer>
								<Image
									src={homeAscentImg}
									className="img-fluid"
								/>
							</ImageContainer>
							<ImageTitle className="mt-1 mb-2">Home Accents</ImageTitle>
						</Link>
					</ImageLink>
				</FirstImageContainer>
			</div>
		</TrendingMainContainer>
	);
}

export default TrendingMain;
